<template>
  <!-- 功能详情页 -->
  <mrc_ess_skeleton_loader :loading="skLoading">
    <div>
      <mrc_ess_iconGroup :is_disabled="disabled"
                         @handleReturn="handleReturn"
                         @handleEdit="handleEdit"
                         @handleDel="handleDel"></mrc_ess_iconGroup>
      <v-card>
        <v-card-text>
          <div style="text-align:right">
            {{ uuid }}
          </div>
          <v-form ref="func_detail">
            <v-row>
              <v-col cols="12"
                     sm="6">
                <!-- 模块名称 -->
                <mrc_ess_multiText :label="$t('label_The_name_of_the_module') + '*'"
                                   :isNational="judegNational('module_name')"
                                   :readonly="disabled"
                                   v-model="detailData.module_name"
                                   append-icon="mdi-longitude"
                                   :error-messages="
                    $errors(
                      'detailData',
                      'module_name',
                      requiredRule.concat(nocharacter)
                    )
                  ">
                </mrc_ess_multiText>
              </v-col>
              <v-col cols="12"
                     sm="6">
                <!-- 短编码 -->
                <mrc_ess_multiText :label="$t('label_short_code_of_module') + '*'"
                                   :isNational="judegNational('module_shortcode')"
                                   :readonly="disabled"
                                   :error-messages="
                    $errors(
                      'detailData',
                      'module_shortcode',
                      requiredRule.concat(nocharacter)
                    )
                  "
                                   v-model="detailData.module_shortcode"
                                   append-icon="mdi-longitude">
                </mrc_ess_multiText>
              </v-col>

              <!-- 上级产品 -->
              <v-col cols="12"
                     sm="6">
                <mrc_ess_prompt obj="products"
                                :disabled="disabled"
                                :rules="false"
                                :label="$t('label_Superior_product') + '*'"
                                @getData="getproducts"
                                v-model="detailData.product_uuid"
                                item-text="view_fields"
                                item-value="uuid"
                                :placeholder="$t('label_Superior_product')"
                                chips
                                :errMsg="$errors('detailData', 'product_uuid', requiredRule)"></mrc_ess_prompt>
                <!-- :rules="[v => v.length > 0 || $t('label.client_type')]" -->
              </v-col>
              <!-- 版本 -->
              <v-col cols="12"
                     sm="6">
                <mrc_ess_prompt :obj="module_version"
                                :disabled="disabled"
                                :rules="false"
                                :label="$t('label_version') + '*'"
                                v-model="detailData.version_uuid"
                                item-text="view_fields"
                                :placeholder="$t('label_version')"
                                chips
                                :errMsg="$errors('detailData', 'version_uuid', requiredRule)"></mrc_ess_prompt>
                <!-- <mrc_ess_input
                  :label="$t('label_version') + '*'"
                  :placeholder="
                    $t('message_Automatically_generated_after_adding')
                  "
                  readonly
                  v-model="detailData.version_uuid"
                  chips
                ></mrc_ess_input> -->
              </v-col>
              <!-- 上级模块 -->
              <v-col cols="12"
                     sm="6">
                <!-- :errMsg="
                    $errors('detailData', 'tricode_parent', requiredRule)
                  " -->
                <mrc_ess_autoComplete :label="$t('label_The_superior_module')"
                                      :readonly="disabled"
                                      moduleView
                                      @changeStaffList="getModuleData"
                                      v-model="detailData.tricode_parent"
                                      :dropDownList="top_module">
                </mrc_ess_autoComplete>
              </v-col>

              <!-- 有模块就用高级参照查找客户端 没有选模块那就用普通参照获取所有的客户端类型 -->
              <v-col cols="12"
                     sm="6">
                <mrc_ess_dictName v-model="computedClientUUID"
                                  :disabled="disabled"
                                  :placeholder="$t('label_Client_type')"
                                  :label="$t('label_Client_type') + '*'"
                                  :rules="false"
                                  multiple
                                  chips
                                  :errMsg="$errors('detailData', 'client_type', requiredRule)"
                                  dict_name="client_type"
                                  v-show="!hasModule">
                </mrc_ess_dictName>
                <mrc_ess_prompt v-show="hasModule"
                                :select_arr="client_type"
                                :label="$t('label_Client_type') + '*'"
                                :disabled="disabled"
                                multiple
                                :no-data-text="$t('label_pleaseSelectModule')"
                                :errMsg="$errors('detailData', 'client_type', requiredRule)"
                                chips
                                v-model="computedClientUUID"></mrc_ess_prompt>
              </v-col>
              <v-col md="12">
                <!-- 描述 -->
                <mrc_ess_multiText :label="$t('label_Module_description') + '*'"
                                   :isNational="judegNational('module_description')"
                                   :readonly="disabled"
                                   v-model="detailData.module_description"
                                   append-icon="mdi-longitude"
                                   :error-messages="
                    $errors(
                      'detailData',
                      'module_description',
                      requiredRule.concat(nocharacter)
                    )
                  ">
                </mrc_ess_multiText>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
      </v-card>
      <mrc_ess_submitBtn v-show="!disabled"
                         @cancel="cancel"
                         :loading="submitloading"
                         @success="success"></mrc_ess_submitBtn>
      <!-- 删除确认框 -->
      <confirm :isOpen="isOpen"
               @onCancel="onCancel"
               :showText="showText"
               @onConfirm="onConfirm"
               :isLoading="isLoading" />
    </div>
  </mrc_ess_skeleton_loader>
</template>

<script>
import {
  getBusinessList,
  get_detail,
  get_update,
  get_add,
  get_del,
} from '@/service/api/func_module'
import { getBusinessList as getPrompt } from '@/service/api/prompt'
import { getDataByName } from '@/service/api/data_dictionary'
// import multiText from '@/components/multi_text'
import confirm from '@/components/confirm'
// import myBtns from '@/components/c_s_btns'
// import iconGroup from '@/components/iconGroup'
import { required } from 'vuelidate/lib/validators'
export default {
  components: { confirm },
  props: {},
  data () {
    return {
      submitloading: false,
      skLoading: false,
      is_del: false,
      isLoading: false,
      showText: '',
      isOpen: false,
      top_module: [],
      disabled: false,
      table: 'mrbase_sys_modules',
      uuid: null,
      version_arr: [],
      detailData: {
        module_name: '',
        module_description: '',
        module_shortcode: '',
        tricode_parent: '',
        client_type: '',
        version_uuid: '',
        product_uuid: '',
        parent_module_uuid: '',
      },
      client_type: [],
    }
  },
  validations: {
    detailData: {
      client_type: {
        required,
      },
      module_name: {
        required,
        nocharacter (value) {
          return this.$myVerify.nocharacter(this.INT(value))
        },
      },
      module_shortcode: {
        required,
        nocharacter (value) {
          return this.$myVerify.nocharacter(this.INT(value))
        },
      },
      module_description: {
        required,
        nocharacter (value) {
          return this.$myVerify.nocharacter(this.INT(value))
        },
      },
      product_uuid: {
        required,
      },
      version_uuid: {
        required,
      },
    },
  },
  // created() {},
  async mounted () {
    await this.national('mrbase_sys_modules')
    this.skLoading = false
    try {
      // 如果有uuid就是修改 就请求详情
      const uuid = this.$route.params.uuid || this.$store.state.uuid
      const name = this.$store.getters.subPage_name
      if (uuid) {
        if (this.$store.state.iconstatus) {
          this.disabled = true
        }
        this.uuid = uuid
        const { data } = await get_detail({ uuid: this.uuid })
        this.detailData = this.$clone(data)
      } else {
        // 没有就是新增就啥也不做
        this.disabled = false
      }
      // await this.getModuleList()
      // 如果有上级产品就去获取模块
      if (this.detailData.product_uuid) {
        await this.getModuleList()
      }
      if (this.detailData.parent_module_uuid) {
        // 客户端类型根据产品和模块来查询，没有模块就根据产品来查询
        const client_type = await getPrompt({
          prompt_name: 'function_client_type',
          module_uuid: this.detailData.parent_module_uuid,
        })
        if (client_type.code == 200) {
          this.client_type = client_type.data
        }
      }
      this.skLoading = false
    } catch (error) {
      this.skLoading = false
    }
  },
  computed: {
    hasModule () {
      return Boolean(this.detailData.parent_module_uuid)
    },
    module_version () {
      return {
        prompt_name: 'module_version',
        product_uuid: this.detailData.product_uuid,
      }
    },
    computedClientUUID: {
      get () {
        let arr = []
        if (this.detailData.client_type) {
          arr = this.$clone(this.detailData.client_type).split(',')
        }
        return arr
      },
      set (val) {
        this.detailData.client_type = val.join()
      },
    },
  },
  watch: {
    disabled: {
      handler (v) {
        if (!this.$store.state.uuid) return
        if (!v) {
          this.$route.meta.title = 'label_edit_module_functions'
          this.$store.commit('set_page_title', 'label_edit_module_functions')
        }
        else {
          this.$route.meta.title = 'label_view_module_functions'
          this.$store.commit('set_page_title', 'label_view_module_functions')
        }
      }, immediate: true
    }
  },
  methods: {
    // 获取产品
    async getproducts () {
      this.detailData.tricode_parent = ''
      this.detailData.parent_module_uuid = ''
      this.detailData.version_uuid = ''
      this.top_module = []
      await this.getModuleList()
    },
    async getModuleData (val) {
      this.detailData.client_type = ''
      this.detailData.parent_module_uuid = val.uuid
      if (Object.keys(val).length > 0) {
        // 客户端类型  高级参照
        const client_type = await getPrompt({
          prompt_name: 'function_client_type',
          module_uuid: val.uuid,
        })
        if (client_type.code == 200) {
          this.client_type = client_type.data
        }
      } else {
      }
    },
    // 获取上级模块
    async getModuleList () {
      // 请求上级模块高级参照
      try {
        const res = await getPrompt({
          prompt_name: 'module_parent',
          uuid: this.uuid,
          product_uuid: this.detailData.product_uuid,
        })
        if (res.code == 200) {
          let data = res.data
          this.top_module = data
          // 客户端类型  高级参照
          const client_type = await getPrompt({
            prompt_name: 'function_client_type',
            module_uuid: this.detailData.parent_module_uuid,
          })
          if (client_type.code == 200) {
            this.client_type = client_type.data
          }
        }
      } catch (err) {
        console.log(err)
      }
    },
    // 取消confirm 弹窗
    onCancel () {
      this.isOpen = false
    },
    // 弹窗确认
    async onConfirm () {
      // 如果是删除弹窗
      if (this.is_del) {
        this.isLoading = true
        const del = await get_del({
          '~table~': this.table,
          uuid: this.uuid,
        })
        if (del.code == 200) {
          this.isLoading = false
          this.$Message({
            text: this.$t('message_The_deletion_was_successful'),
          })
          this.$router.go(-1)
        }
      } else {
        // 取消弹窗
        this.$router.go(-1)
      }
    },
    // 新增 修改取消
    async cancel () {
      if (this.uuid) {
        const { data } = await get_detail({ uuid: this.uuid })
        this.detailData = this.$clone(data)
        this.disabled = true
      }
      else {
        this.$myConfirm({
          content: this.$t('message_Confirm_the_cancellation_of_the_edit'),
        })
          .then(() => {
            this.$router.go(-1)
          })
          .catch(() => { })
      }
      // if (this.uuid) {
      //   this.showText = '放弃修改'
      // } else {
      //   this.showText = '放弃新增'
      // }
      // this.isOpen = true
    },
    async success () {
      this.$v.detailData.$touch()
      if (this.$v.detailData.$error) {
        return
      }
      const obj = {
        // "~table~": this.table,
        module_description: this.detailData.module_description,
        module_name: this.detailData.module_name,
        module_shortcode: this.detailData.module_shortcode,
        tricode_parent: this.detailData.tricode_parent,
        uuid: this.uuid,
        version_uuid: this.detailData.version_uuid,
        client_type: this.detailData.client_type,
        // org_level_uuid: this.$store.state.userData.org_level_uuid,
        product_uuid: this.detailData.product_uuid,
      }
      this.submitloading = true
      // 修改
      if (this.uuid) {
        const update = await get_update(obj)
        if (update.code == 200) {
          this.$Message({
            text: this.$t('message_The_operation_was_successful'),
          })
          // this.$router.go(-1)
          const { data } = await get_detail({ uuid: this.uuid })
          this.detailData = this.$clone(data)
          this.disabled = true
        }
        // else {
        //   this.$store.commit(
        //     'newsTips',
        //     this.$t('message_The_modification_failed')
        //   )
        // }
      }
      else {
        // 新增
        const add = await get_add(obj)
        if (add.code == 200) {
          this.$Message({ text: this.$t('message_added_successfully') })
          this.$router.go(-1)
        }
        // else {
        //  
        // }
      }
      this.submitloading = false
    },
    // 返回
    handleReturn () {
      this.$router.go(-1)
    },
    // 修改按钮
    handleEdit () {
      this.disabled = !this.disabled
    },
    // 删除按钮
    handleDel () {
      // this.isOpen = true
      // this.is_del = true
      // this.showText = '是否删除'
      this.$myConfirm({ content: this.$t('message_Confirm_the_deletion') })
        .then(async () => {
          const del = await get_del({
            '~table~': this.table,
            uuid: this.uuid,
          })
          if (del.code == 200) {
            this.isLoading = false
            this.$Message({
              text: this.$t('message_The_deletion_was_successful'),
            })
            this.$router.go(-1)
          }
        })
        .catch(() => { })
    },
  },
}
</script>

<style scoped></style>
